"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _edSystem = require("@eduact/ed-system");
var _utils = require("@eduact/utils");
var _Icons = require("../../Icons");
var _Spacer = _interopRequireDefault(require("../../Spacer"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GapQuestion = _interopRequireDefault(require("../GapQuestion/GapQuestion"));
var _McqQuestion = require("../McqQuestion");
var _OrderingQuestion = require("../OrderingQuestion");
var _Question = require("../Question.types");
var _EssayQuestion = require("../EssayQuestion");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var TestQuestion = function TestQuestion(_ref) {
  var question = _ref.question,
    essayQuestionProps = _ref.essayQuestionProps,
    _ref$withNavigation = _ref.withNavigation,
    withNavigation = _ref$withNavigation === void 0 ? false : _ref$withNavigation,
    onNext = _ref.onNext,
    onPrev = _ref.onPrev,
    index = _ref.index,
    onChange = _ref.onChange,
    _ref$showNext = _ref.showNext,
    showNext = _ref$showNext === void 0 ? true : _ref$showNext,
    _ref$showPrev = _ref.showPrev,
    showPrev = _ref$showPrev === void 0 ? true : _ref$showPrev,
    _ref$nextLabel = _ref.nextLabel,
    nextLabel = _ref$nextLabel === void 0 ? 'Next' : _ref$nextLabel,
    _ref$prevLabel = _ref.prevLabel,
    prevLabel = _ref$prevLabel === void 0 ? 'Previous' : _ref$prevLabel,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    questionLabel = _ref.questionLabel,
    scoreLabel = _ref.scoreLabel;
  return /*#__PURE__*/_react["default"].createElement(QuestionContainer, {
    tabIndex: question.id,
    onFocus: onFocus,
    onBlur: onBlur
  }, /*#__PURE__*/_react["default"].createElement(QuestionWrapper, null, /*#__PURE__*/_react["default"].createElement(QuestionHeader, null, /*#__PURE__*/_react["default"].createElement(QuestionOrder, null, questionLabel !== null && questionLabel !== void 0 ? questionLabel : "Q".concat(index + 1, "."), " "), /*#__PURE__*/_react["default"].createElement(QuestionPoints, null, /*#__PURE__*/_react["default"].createElement(Points, null, scoreLabel !== null && scoreLabel !== void 0 ? scoreLabel : 'Points', " "), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mx: '0.5rem'
  }), /*#__PURE__*/_react["default"].createElement("span", null, (0, _utils.NumberFormatter)(question.weight)))), /*#__PURE__*/_react["default"].createElement(_Spacer["default"], {
    mb: {
      sm: '1rem',
      lg: '2rem'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, (0, _Question.isGapQuestion)(question) && /*#__PURE__*/_react["default"].createElement(_GapQuestion["default"], {
    label: "Q".concat(question.order, "."),
    onChange: onChange,
    question: question
  }), (0, _Question.isOrderingQuestion)(question) && /*#__PURE__*/_react["default"].createElement(_OrderingQuestion.OrderingQuestion, {
    onFocus: onFocus,
    onBlur: onBlur,
    question: question,
    onChange: onChange
  }), (0, _Question.isMcqQuestion)(question) && /*#__PURE__*/_react["default"].createElement(_McqQuestion.McqQuestion, {
    question: question,
    onChange: onChange
  }), (0, _Question.isEssayQuestion)(question) && /*#__PURE__*/_react["default"].createElement(_EssayQuestion.EssayQuestion, _extends({
    question: question,
    onChange: onChange
  }, essayQuestionProps)))), withNavigation && /*#__PURE__*/_react["default"].createElement(_edSystem.FlexLayout, {
    alignItems: 'center',
    justifyContent: 'space-between'
  }, showPrev ? /*#__PURE__*/_react["default"].createElement(NavigationButton, {
    onClick: function onClick() {
      return onPrev === null || onPrev === void 0 ? void 0 : onPrev(question.order, index);
    },
    alignItems: 'center'
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "primary"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.ChevronLeft, null)), /*#__PURE__*/_react["default"].createElement("span", null, prevLabel)) : /*#__PURE__*/_react["default"].createElement("span", null), showNext ? /*#__PURE__*/_react["default"].createElement(NavigationButton, {
    onClick: function onClick() {
      return onNext === null || onNext === void 0 ? void 0 : onNext(question.order, index);
    },
    alignItems: 'center'
  }, /*#__PURE__*/_react["default"].createElement("span", null, nextLabel), /*#__PURE__*/_react["default"].createElement(_Icons.Icon, {
    color: "primary"
  }, /*#__PURE__*/_react["default"].createElement(_Icons.Icons.ChevronRight, null))) : /*#__PURE__*/_react["default"].createElement("span", null)));
};
var _default = TestQuestion;
exports["default"] = _default;
var QuestionContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\timg {\n\t\tdisplay: block;\n\t\theight: auto;\n\t}\n\tbox-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n\tbackground: #fff;\n\tpadding: 1rem;\n\tborder-radius: 8px;\n"])), _edSystem.DefaultBrowserCss);
var QuestionWrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.large, "{\n\tpadding : 0 8rem;\n}");
});
var QuestionHeader = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tborder-bottom: 2px solid #d3d3d3;\n\tpadding-bottom: 8px;\n\talign-items: center;\n\t", "\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tpadding-bottom : 2rem;\n\t}");
});
var QuestionOrder = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tfont-size: 10px;\n\tfont-weight: bold;\n\t", "\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tfont-size : 20px;\n\t}");
});
var QuestionPoints = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tfont-size: 8px;\n\tfont-weight: bold;\n\tdisplay: flex;\n\talign-items: center;\n\t", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\tfont-size : 16px;\n\t}");
});
var NavigationButton = (0, _styledComponents["default"])(_edSystem.FlexLayout).attrs(function (p) {
  return {
    dir: document.documentElement.dir
  };
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n\tcursor: pointer;\n\ttransition: opacity ease-in-out 300ms;\n\t&[dir='rtl'] {\n\t\tsvg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\t&:hover {\n\t\topacity: 0.8;\n\t}\n"])), function (props) {
  return props.theme.colors.primary;
});
var Points = (0, _styledComponents["default"])(_edSystem.Typography)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tcolor: ", ";\n"])), function (props) {
  return props.theme.colors.silver;
});